import React from 'react';
import { UserIcon, PhoneIcon, EnvelopeIcon, BuildingOfficeIcon } from '@heroicons/react/24/outline';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface ContactSectionProps {
  contactName: string | null;
  contactPhone: string | null;
  contactEmail: string | null;
  description: string | null;
  isLoading: boolean;
}

const ContactSection: React.FC<ContactSectionProps> = ({
  contactName,
  contactPhone,
  contactEmail,
  description,
  isLoading
}) => {
  return (
    <div className="bg-white shadow rounded-lg overflow-hidden border border-gray-200">
      <div className="px-4 py-5 sm:px-6 bg-blue-50 border-b border-gray-200">
        <div className="flex items-center">
          <div className="bg-blue-100 rounded-full p-2 mr-3">
            <UserIcon className="h-6 w-6 text-blue-600" />
          </div>
          <h3 className="text-lg font-medium leading-6 text-gray-900">
            Contact
          </h3>
        </div>
        <p className="mt-1 max-w-2xl text-sm text-gray-500">
          Informations saisies manuellement
        </p>
      </div>

      <div className="p-6 space-y-6">
        {isLoading ? (
          <div className="space-y-4">
            <Skeleton height={24} width="50%" />
            <Skeleton count={6} />
          </div>
        ) : (
          <>
            <div className="flex items-center">
              <div className="bg-gray-100 rounded-full p-2 mr-4">
                <UserIcon className="h-5 w-5 text-gray-600" />
              </div>
              <div>
                <p className="text-xs text-gray-500">Nom</p>
                <p className="text-sm font-medium">{contactName || 'Non spécifié'}</p>
              </div>
            </div>

            <div className="flex items-center">
              <div className="bg-gray-100 rounded-full p-2 mr-4">
                <EnvelopeIcon className="h-5 w-5 text-gray-600" />
              </div>
              <div>
                <p className="text-xs text-gray-500">Email</p>
                {contactEmail ? (
                  <a href={`mailto:${contactEmail}`} className="text-sm font-medium text-blue-600 hover:underline">
                    {contactEmail}
                  </a>
                ) : (
                  <p className="text-sm font-medium">Non spécifié</p>
                )}
              </div>
            </div>

            <div className="flex items-center">
              <div className="bg-gray-100 rounded-full p-2 mr-4">
                <PhoneIcon className="h-5 w-5 text-gray-600" />
              </div>
              <div>
                <p className="text-xs text-gray-500">Téléphone</p>
                {contactPhone ? (
                  <a href={`tel:${contactPhone}`} className="text-sm font-medium text-blue-600 hover:underline">
                    {contactPhone}
                  </a>
                ) : (
                  <p className="text-sm font-medium">Non spécifié</p>
                )}
              </div>
            </div>

            <div className="border-t border-gray-200 pt-4 mt-4">
              <div className="flex items-center">
                <div className="bg-gray-100 rounded-full p-2 mr-4">
                  <BuildingOfficeIcon className="h-5 w-5 text-gray-600" />
                </div>
                <div className="flex-1">
                  <p className="text-xs text-gray-500">Description de l'organisation</p>
                  <p className="text-sm">{description || 'Non spécifié'}</p>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ContactSection;